export const IS_PROD = process.env.NODE_ENV === 'production'
export const IS_DEV = process.env.NODE_ENV === 'development'

export const GOOGLE_MAPS_API_KEY = process.env.GOOGLE_MAPS_API_KEY
export const SEGMENT_API_KEY = process.env.SEGMENT_API_KEY
export const SENTRY_DSN = process.env.REACT_SENTRY_DSN
export const INTERCOM_APP_ID = process.env.INTERCOM_APP_ID
export const PUSHER_APP_KEY = process.env.PUSHER_APP_KEY
export const PUSHER_CLUSTER = process.env.PUSHER_CLUSTER
